import React from 'react';
import { MenuItem } from '@mui/material';
import { TextInput } from '@awarego-ui/components';
import TextFieldWithRevert from './TextFieldWithRevert';
import CustomizableHtmlField from './CustomizableHtmlField';
import SmartVariablesPanel from './SmartVariablesPanel';
import { REPORT_EMAIL_TYPES, SMART_VARIABLES } from './constants';

const NOTE_TEXT =
    'Note: Only default texts are automatically translated into the user’s language. Any changes you make turn the text into a custom version that is used exactly as written. When the checkbox is off, the translated default text is used; when it’s on, your custom content is used.';

function ReportEmailTab({
    form,
    reportType,
    onReportTypeChange,
    initialValue,
    onEnabledChange,
    defaultValues,
    onRevertField,
    onCopyVariable,
}) {
    const selected =
        REPORT_EMAIL_TYPES.find((type) => type.id === reportType) ||
        REPORT_EMAIL_TYPES[0];
    const subjectFieldName = `${selected.key}_subject`;
    const textFieldName = `${selected.key}_text`;
    const variables =
        selected.id === 'department-manager'
            ? SMART_VARIABLES.reportDepartment
            : SMART_VARIABLES.report;
    const defaultSubject = defaultValues?.[`ui.email.${subjectFieldName}`];
    const defaultText = defaultValues?.[`ui.email.${textFieldName}`];

    return (
        <div className="row">
            <div className="col-md-8">
                <br />
                <p
                    style={{
                        fontSize: '14px',
                        color: '#666',
                        fontStyle: 'italic',
                        marginBottom: '16px',
                    }}
                >
                    {NOTE_TEXT}
                </p>
                <TextInput
                    select
                    label="Report type"
                    value={selected.id}
                    onChange={(e) => onReportTypeChange(e.target.value)}
                >
                    {REPORT_EMAIL_TYPES.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                            {type.label}
                        </MenuItem>
                    ))}
                </TextInput>
                <div className="form-group">
                    <TextFieldWithRevert
                        field={form.$(subjectFieldName)}
                        defaultValue={defaultSubject}
                        onRevert={onRevertField}
                        linkBelow
                        linkLabel="Reset to default"
                    />
                </div>
                <CustomizableHtmlField
                    label={`Customize Text for ${selected.label} emails`}
                    fieldName={textFieldName}
                    enabledFieldName={`${textFieldName}Enabled`}
                    form={form}
                    initialValue={initialValue}
                    onEnabledChange={onEnabledChange}
                    defaultValue={defaultText}
                    showReset
                />
            </div>
            <div className="col-md-4">
                <SmartVariablesPanel
                    variables={variables}
                    onCopyVariable={onCopyVariable}
                />
            </div>
        </div>
    );
}

export default ReportEmailTab;
